module.exports = __webpack_public_path__ + "06a9b8b91721daa2838788688702f705.png";